import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";
import { FinsharkCallbackListener } from "components/MoneyModals/FinsharkCallbackHandler";
import { UpdateInfoNotification } from "components/Notifications/UpdateInfoNotification";
import { useTrackingScripts } from "hooks/useTrackingScripts";
import PublicWaitPortfolioActivation from "pages/onfidoOnboarding/publicWaitPortfolioActivation";
import SignicatRedirect from "pages/onfidoOnboarding/signicatRedirect";
import { APILanguageProvider } from "providers/APILanguageProvider/APILanguageProvider";
import { DetailProvider } from "providers/ContactIdProvider";
import { InitialLanguageProvider } from "providers/InitialLanguageProvider";
import { KeycloakProvider } from "providers/KeycloakProvider";
import { PersistedApolloProvider } from "providers/PersistedApolloProvider";
import { ServiceWorkerRegistrationProvider } from "providers/ServiceWorkerRegistrationProvider";
import { ThemeProvider } from "providers/ThemeProvider";
import { Routes, Route } from "react-router-dom";
import { usePushNotifications } from "utils/mobile";
import { PublicOnboardingFormView } from "views/onboarding/publicOnboarding";
import { ZimplerCallbackHandler } from "views/transfers/components/ZimplerCallbackHandler";
import { Toast } from "./components";
import { MaintenanceWrapper } from "./MaintenanceWrapper";
import PublicOnboarding from "./pages/onfidoOnboarding/publicOnboarding";
import { UserWithLinkedContactRoutes } from "./pages/userWithLinkedContact/routes";
import "react-toastify/dist/ReactToastify.css";
import "styles/fonts.css";

function App() {
  useTrackingScripts();
  usePushNotifications();

  return (
    <InitialLanguageProvider>
      <ThemeProvider>
        <ServiceWorkerRegistrationProvider>
          <ErrorBoundary>
            <Routes>
              <Route path="/public-onboarding" element={<PublicOnboarding />} />
              <Route
                path="/public-wait-portfolio-activation"
                element={<PublicWaitPortfolioActivation />}
              />
              <Route
                path="/onboarding/publicOnboarding"
                element={<PublicOnboardingFormView />}
              />
              <Route path="/signicat" element={<SignicatRedirect />} />
              <Route
                path="/*"
                element={
                  <KeycloakProvider>
                    <PersistedApolloProvider>
                      <DetailProvider>
                        <APILanguageProvider>
                          <MaintenanceWrapper>
                            <UpdateInfoNotification />
                            <FinsharkCallbackListener />
                            <ZimplerCallbackHandler />
                            <UserWithLinkedContactRoutes />
                          </MaintenanceWrapper>
                        </APILanguageProvider>
                      </DetailProvider>
                      <Toast />
                    </PersistedApolloProvider>
                  </KeycloakProvider>
                }
              />
            </Routes>
          </ErrorBoundary>
        </ServiceWorkerRegistrationProvider>
      </ThemeProvider>
    </InitialLanguageProvider>
  );
}

export default App;
